import React from 'react';
import { Result } from 'antd';
import { useLocation } from 'react-router-dom';
import usePermissions from '../../hooks/usePermissions';

/**
 * Bloquea por ruta a los roles con restricciones que se hacen cumplir (ver
 * ENFORCED_ROLES): un Asesor no puede entrar a "Mis números" ni a la reportería
 * escribiendo la dirección, aunque el menú ya no se la muestre. Para el resto de roles
 * y para los administradores no hace nada: sus permisos siguen siendo solo de menú.
 */
const EnforceRolePermissions = ({ children }) => {
  const location = useLocation();
  const { restrictedRole, canPath } = usePermissions();

  if (restrictedRole && !canPath(location.pathname)) {
    return (
      <Result
        status="403"
        title="Sin acceso"
        subTitle="Tu rol no tiene permisos para ver esta sección. Pídele a un administrador que te dé acceso."
      />
    );
  }
  return children;
};

export default EnforceRolePermissions;
